import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api');

const BASE = `${API_BASE_URL}/opencode-chats`;

const OpenCodeChatService = {
  async overview() {
    return (await axios.get(BASE)).data;
  },
  async start(version) {
    return (await axios.post(BASE, { version })).data;
  },
  // With the revision the page already has, returns { unchanged: true } if nothing changed.
  async get(id, revision) {
    const params = revision === undefined ? {} : { revision };
    return (await axios.get(`${BASE}/${id}`, { params })).data;
  },
  // A link that opens the chat in OpenCode's own web UI.
  async uiLink(id) {
    return (await axios.post(`${BASE}/${id}/ui`)).data;
  },
  async commit(id, note) {
    return (await axios.post(`${BASE}/${id}/commit`, { note })).data;
  },
  async stop(id) {
    return (await axios.post(`${BASE}/${id}/stop`)).data;
  },
  async image(id, imageId) {
    return (await axios.get(`${BASE}/${id}/images/${imageId}`, { responseType: 'blob' })).data;
  },
  async restore(version) {
    return (await axios.post(`${BASE}/sessions/${version}/restore`)).data;
  },
};

export default OpenCodeChatService;
